import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDeepCompareMemo } from "@ispb/react-hooks";
import { Lazy, useLazyState, useObservableLazy } from "@ispb/react-lazy";
import { Table } from "react-bootstrap";
import { combineLatest } from "rxjs";
import Blocker from "../components/Blocker.js";
import { INVISIBLE_RELOADING } from "../lazy/index.js";
export default function PropertiesTable(props) {
    const properties = useObservableLazy({
        of: useDeepCompareMemo(() => {
            return combineLatest(props.properties);
        }, [
            props.properties
        ])
    });
    const state = useLazyState(properties);
    return (_jsx(Blocker, { blocking: state.isReloading, children: _jsx(Table, { className: "w-100 mb-0", children: _jsx("tbody", { children: Object.keys(props.properties).map(label => (_jsxs("tr", { children: [_jsxs("td", { children: [label, ":"] }), _jsx("td", { className: "text-end overflow-hidden", style: { textOverflow: "ellipsis" }, children: _jsx(Lazy, { event: properties, overrides: { onReloading: INVISIBLE_RELOADING, onLoading: () => "..." }, children: value => value[label] }) })] }, label))) }) }) }));
}
